<template>
  <div id="glossary-tpm" class="tpm-search-container">
    <div class="tpm-header-container"></div>
    <!-- <label for="search" id="search-label">Search</label> -->
    <!-- <input type="search" name="search" id="search-input"> -->
    <div class="tpm-header-search">
      <!-- <img class="close-modal" src="@/assets/icons/Asset 37.png" alt @click="closeModal" /> -->
      <div class="search-input">
        <input
          id="search-input"
          v-model="search"
          class="search"
          type="search"
          :placeholder="$t('lessonSearch.search')"
          name="search-input"
        />
      </div>
      <span>{{ $t('global.glossary') }}</span>
    </div>
    <!-- <ul class="abc-container">
      <li @click="letterSelection(letter.letter)" v-for="letter in glossary.letters" :key="letter.letter" class="letters-container">
        {{letter.letter}}
      </li>
    </ul>-->
    <div class="results-container">
      <div v-for="glossary in filteredList" :key="glossary.id" class="book-card">
        <p class="definition">
          <span class="word">{{ glossary.word }}.-</span>
          <span class="word-definition">{{ glossary.definition }}</span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
  props: ['grade', 'cluster'],
  data() {
    return {
      search: '',
      glossary: [],
    };
  },
  computed: {
    ...mapGetters({
      lang: 'app/language',
    }),
    filteredList() {
      console.log(this.glossary.glossaries);
      return this.glossary.filter(gllossary => {
        console.log(gllossary);
        return gllossary.word.toLowerCase().includes(this.search.toLowerCase());
      });
    },
  },
  beforeCreate() {
    var payload = {
      width: '90',
      prefixWidth: 'vw',
      height: '90',
      prefixHeight: 'vh',
    };
    this.$store.commit('SET_STYLE_MODAL', payload);
  },
  created() {
    this.getGlossaryDB();
  },
  methods: {
    closeModal() {
      this.$store.commit('SIDEBAR_ACTIVE_CLASS', { item: 'Glossary', active: false });
      this.$store.state.modalTools.glossaryModal = false;
    },
    getGlossaryDB() {
      this.$store.commit('app/START_PROCESSING');
      this.$httpMain
        .post(`glossary`, {
          grade_id: this.$route.params.grade_id,
          subject_id: Number.parseInt(this.$route.params.subject_id),
          token: this.$store.state.cookie,
          lang: this.lang,
        })
        .then(res => {
          this.glossary = res.data;
          console.log(res.data);
        })
        .finally(() => {
          this.$store.commit('app/STOP_PROCESSING');
        });

      // console.log(this.request)
      // this.$httpMain
      //   .post(`glossary`, {
      //     grade_id: 'Grade 3',
      //     subject_id: this.$store.state.currentSubject.current.id,
      //     token: this.$store.state.cookie,
      //     lang: this.$store.state.language,
      //   })
      //   .then(res => {
      //     this.$set(this.$data, 'glossary', res.data);
      //     console.log(res.data);
      //   });
    },
    letterSelection(letter) {
      this.search = letter;
    },
  },
};
</script>
<style lang="scss" scoped>
.tpm-search-container {
  height: 95vh;
}
.tpm-header-search {
  position: absolute;
  top: 37px; ///HERE top: 0px;
  height: 90px;
  // width: 2000px;
  right: -31px;
  left: -2px;
  // width: 100%;
  background: #156b96;
  // box-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.4);
  font-weight: bold;
  font-size: 40px;
  display: flex;
  align-items: center;
  text-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.65);
  border-top-left-radius: 10px;
  span {
    font-family: 'comfortaabold';
    color: #fff;
    margin: 30px;
  }
}
.search-input {
  margin: 15px 0;
  display: flex;
  align-items: center;
  position: absolute;
  right: 10%;
  margin: 0;
}
.tpm-header-search:after,
.arrow_box:before {
  top: 100%;
  z-index: -1;
  right: 0;
  border: solid transparent;
  content: ' ';
  height: 0;
  width: 0;
  position: absolute;
  pointer-events: none;
}

.tpm-header-search:after {
  border-color: rgba(136, 183, 213, 0);
  border-top-color: #0a3144;
  border-width: 30px;
  margin-left: -30px;
}
.tpm-header-search:before {
  border-color: rgba(194, 225, 245, 0);
  border-top-color: #0a3144;
  border-width: 36px;
  margin-left: -36px;
}
.title {
  font-family: 'comfortaabold';
  font-size: 30px;
  color: #2e9ab4;
  &:hover {
    color: #2e9ab4;
  }
  &.subject {
    margin-left: 20px;
  }
  &.cluster {
    margin-left: 40px;
  }
  &.lesson {
    margin-left: 60px;
  }
}
.result {
  font-family: 'comfortaabold';
  font-size: 40px;
  margin-left: 28px;
  color: #2e9ab4;
}
.results-container {
  position: absolute;
  overflow-x: hidden;
  overflow-y: auto;
  top: 130px; //top: 95px
  left: 20px;
  right: 20px;
  bottom: 20px;
  .results-box {
    margin: 20px;
  }
}
.results-container::-webkit-scrollbar {
  width: 8px;
  border-radius: 10px 10px 10px 10px;
  background: #67afd5;
}
.results-container::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  border-radius: 10px;
}
.results-container::-webkit-scrollbar-thumb {
  border-radius: 10px 10px 10px 10px;
  background: #17699b;
  &:hover {
    background: #5691b6;
  }
}
.text-result {
  font-family: 'comfortaabold';
  font-size: 30px;
  color: #000;
  &:hover {
    color: #5493b2;
    font-size: 31px;
  }
}
.close-modal {
  position: absolute;
  right: -20px;
  top: -5px;
  height: 50;
  width: 50px;
  cursor: pointer;
  &:hover {
    transform: scale(1.01);
  }
}
a {
  text-decoration: none;
}
.tpm-header-container {
  // position: absolute;
  height: 90px;
  // right: -10px;
  // width: 100%;
  // width: 2000px;
  // background: #156b96;
  font-family: 'comfortaabold';
  font-weight: bold;
  font-size: 40px;
  display: flex;
  align-items: center;
  color: #fff;
  text-shadow: 5px 5px 10px rgba($color: #000000, $alpha: 0.65);
}
input[type='search'] {
  background-color: #fff !important;
  width: 150px;
  display: block;
  // margin-bottom: 10px;
  // background-color: yellow;
  border-radius: 20px;
  font-family: 'comfortaabold';
  border: 2px solid #999999;
  margin-left: 30px;
  height: 48px;
  width: 500px;
  font-size: 30px;
  color: #000000;
  background: url('~@/assets/icons/lupa.svg') no-repeat scroll 440px 5px;
  // padding-left: 200px;
  text-align: center;
  &:focus-within {
    border: 2px solid #7faec5;
  }
}
::placeholder {
  color: #999999;
  opacity: 1; /* Firefox */
}
.word {
  font-family: 'comfortaabold';
  color: #2e9ab4;
  font-size: 25px;
}
.word-definition {
  font-family: 'comfortaabold';
  color: #000000;
  font-size: 20px;
  line-height: 1.3;
}
.book-card {
  margin: 40px 15px 40px 15px;
}
@media (max-width: 576px) {
  input[type='search'] {
    margin-left: 30px;
    height: 35px;
    width: 300px;
    font-size: 20px;
    background: url('~@/assets/icons/lupa.svg') no-repeat scroll 240px 1px;
  }
  .tpm-header-search {
    span {
      visibility: hidden;
    }
  }
}
@media (min-width: 568px) and (max-width: 767px) {
  .tpm-header-search {
    span {
      font-size: 20px;
    }
  }
  input[type='search'] {
    margin-left: 30px;
    height: 40px;
    width: 400px;
    font-size: 20px;
    background: url('~@/assets/icons/lupa.svg') no-repeat scroll 350px 3px;
  }
}
@media (min-width: 768px) and (max-width: 850px) {
  .tpm-header-search {
    span {
      font-size: 25px;
    }
  }
}
</style>
